import styled from "styled-components";

export const SobreMi = styled.p`
  width: 100px;
  color: black;
  transform: rotate(-90deg);
  font-size: 18px;
  @media (max-width: 376px) {
    display: none;
  }
`;
